import React from 'react'
import './styles'

# get the previous midnight as a reference point, once per load
midnight = new Date
midnight.setHours 0, 0, 0, 0

time = ->
  now = new Date
  hours:    now.getHours() % 12
  minutes:  now.getMinutes()
  seconds:  now.getSeconds()
  elapsed:  Math.floor (now.getTime() - midnight.getTime()) / 1000

export default \
class Clock extends React.Component
  constructor: ->
    super arguments...
    @state = { show: false, time()... }
    # fade in
    setTimeout @setState.bind(@, show: true), 1000

  updateTime: =>
    @setState time()

  blankScreen: =>
    @setState show: false

  componentDidMount: =>
    @interval = setInterval @updateTime, 1000
    # turn off after 10 minutes
    @timeout = setTimeout @blankScreen, 10 * 60 * 1000

  componentWillUnmount: =>
    clearInterval @interval
    clearTimeout @timeout

  render: ->
    <div
      className="Clock"
      style={opacity: @state.show + 0}
    >
      {@hourHand()}
      {@minuteHand()}
      {@secondHand()}
    </div>

  hourHand: =>
    <div
      className="hour"
      style={transform: "rotate(#{360 / 12 * @state.elapsed / 60 / 60}deg)"}
    />

  minuteHand: =>
    <div
      className="minute"
      style={transform: "rotate(#{360 / 60 * @state.elapsed / 60}deg)"}
    />

  secondHand: =>
    <div
      className="second"
      style={transform: "rotate(#{(360 / 60) * @state.elapsed}deg)"}
    />
